// Libs
import React from 'react'

// CSS
import './styles.scss'

const HeaderHamburguerIcon = ({ visible, ...props }) => (
  <div
    className={visible ? "header-hamburguer-icon header-hamburguer-icon--close" : "header-hamburguer-icon header-link--active"}
    {...props}>
    <div className="header-hamburguer-icon__border" />
    <div className="header-hamburguer-icon__wrapper">
      <div className="header-hamburguer-icon__line" />
      <div className="header-hamburguer-icon__line" />
      <div className="header-hamburguer-icon__line" />
    </div>
  </div>
)

export default HeaderHamburguerIcon
